module.exports = __webpack_public_path__ + "static/img/child-intro-section-bg-img.fc2c649.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/child-intro-section-bg-img.jpg
// module id = ywLO
// module chunks = 3